var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_group_nav)?_c('div',{staticClass:"group-props-container m-b-15 m-t--15"},[_c('horizontal-nav',{attrs:{"items":_vm.group_items,"show_display":false,"prop_name":"name","selected_item_value":_vm.selected_group_title},on:{"setSelected":_vm.set_selected_group}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }